/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Whatsapp_Link_Dialog_Open_WaInputs */

const he_account_delivery_whatsapp_link_dialog_open_wa = /** @type {(inputs: Account_Delivery_Whatsapp_Link_Dialog_Open_WaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פתח WhatsApp`)
};

const en_account_delivery_whatsapp_link_dialog_open_wa = /** @type {(inputs: Account_Delivery_Whatsapp_Link_Dialog_Open_WaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open WhatsApp`)
};

/**
* | output |
* | --- |
* | "Open WhatsApp" |
*
* @param {Account_Delivery_Whatsapp_Link_Dialog_Open_WaInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_whatsapp_link_dialog_open_wa = /** @type {((inputs?: Account_Delivery_Whatsapp_Link_Dialog_Open_WaInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Whatsapp_Link_Dialog_Open_WaInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_whatsapp_link_dialog_open_wa(inputs)
	return en_account_delivery_whatsapp_link_dialog_open_wa(inputs)
});